import { NotificationTwoTone } from '@ant-design/icons';
import { Space } from 'antd';
import moment from 'moment';
import React from 'react';

import type { ProgramDetailValues } from '../../types';
import { PricingSection } from './components/PricingSection';
import { displayDateTimeString } from './helpers';
import styles from './index.module.scss';
import type { AmountOptions } from './types';

type ProgramDetailProps = {
  program: ProgramDetailValues;
  showProgramSchedule: () => void;
  statusSection?: { title: string; content: string }[];
  news?: string;
  amountOptions?: AmountOptions;
};

export const ProgramDetail = ({
  program,
  showProgramSchedule,
  statusSection,
  news,
  amountOptions,
}: ProgramDetailProps) => {
  const programPeriod = displayDateTimeString({
    startTime: moment(program.program.startTime),
    endTime: moment(program.program.endTime),
  });

  return (
    <div className={styles.modalContent}>
      <div className={styles.imageContainer}>
        <img src={program.image || '/noImage.svg'} alt="育樂活動圖片" />
      </div>

      <div className={styles.section}>
        <h1>{program.name}</h1>
      </div>

      {statusSection ? (
        <div className={styles.section}>
          <Space direction="vertical" size="middle">
            <Space>
              <NotificationTwoTone rev={undefined} />
              <h4 className={styles.sectionTitle}>活動狀態：</h4>
            </Space>
            {statusSection.map((item, index) => (
              <div key={index} className={styles.subSection}>
                <h5>{item.title}</h5>
                <p>{item.content}</p>
              </div>
            ))}
          </Space>
        </div>
      ) : null}

      {news ? (
        <div className={styles.section}>
          <Space direction="vertical" size="middle">
            <Space>
              <NotificationTwoTone rev={undefined} />
              <h4 className={styles.sectionTitle}>最新消息：</h4>
            </Space>
            <div className={styles.subSection}>
              <h5>最新消息</h5>
              <p className={styles['pre-wrap']}>{news}</p>
            </div>
          </Space>
        </div>
      ) : null}

      <div className={styles.section}>
        <Space direction="vertical" size="middle">
          <Space>
            <NotificationTwoTone rev={undefined} />
            <h4 className={styles.sectionTitle}>活動內容：</h4>
          </Space>
          <div className={styles.subSection}>
            <h5>活動類別</h5>
            <p>{program.category}</p>
          </div>
          <div className={styles.subSection}>
            <h5>活動介紹</h5>
            <p className={styles['pre-wrap']}>{program.description}</p>
          </div>
          <div className={styles.subSection}>
            <h5>費用包含</h5>
            <p className={styles['pre-wrap']}>{program.includedPayment}</p>
          </div>
        </Space>
      </div>

      <div className={styles.section}>
        <Space direction="vertical" size="middle">
          <Space>
            <NotificationTwoTone rev={undefined} />
            <h4 className={styles.sectionTitle}>活動資訊：</h4>
          </Space>
          <div className={styles.subSection}>
            <h5>講師</h5>
            <p>{program.teacher}</p>
          </div>
          <div className={styles.subSection}>
            <h5>活動起迄日期</h5>
            {program.isRegular ? (
              <button
                className={styles.linkButton}
                onClick={showProgramSchedule}
              >
                {programPeriod}
              </button>
            ) : (
              <p>{programPeriod}</p>
            )}
          </div>
          <div className={styles.subSection}>
            <h5>活動上限人數</h5>
            <p>{program.maximumEnrollment}</p>
          </div>
          <div className={styles.subSection}>
            <h5>活動成團人數</h5>
            <p>{program.minimumEnrollment}</p>
          </div>
          <div className={styles.subSection}>
            <h5>報名起迄時間</h5>
            <p>
              {displayDateTimeString({
                startTime: moment(program.enrollment.startTime),
                endTime: moment(program.enrollment.endTime),
                format: 'YYYY/MM/DD HH:mm',
              })}
            </p>
          </div>
        </Space>
      </div>

      <div className={styles.section}>
        <Space direction="vertical" size="middle">
          <Space>
            <NotificationTwoTone rev={undefined} />
            <h4 className={styles.sectionTitle}>活動須知：</h4>
          </Space>
          <div className={styles.subSection}>
            <h5>注意事項</h5>
            <p className={styles['pre-wrap']}>{program.note}</p>
          </div>
          <div className={styles.subSection}>
            <h5>退費規則</h5>
            <p>{program.refundPolicy}</p>
          </div>
        </Space>
      </div>

      <PricingSection pricing={program.pricing} amountOptions={amountOptions} />
    </div>
  );
};
